'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var eventClasses = exports.eventClasses = ['activation', 'creation', 'error', 'exposure', 'funnel', 'interaction', 'none', 'signup', 'usage', 'view', 'warning'];

var eventPropertyTypes = exports.eventPropertyTypes = ['boolean', 'string', 'number', 'array'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.76/js/dictionary/taxonomy.js
// module id = 183
// module chunks = 0